export default "__VITE_ASSET__DpGZ3cAX__"